module.exports = __webpack_public_path__ + "img/confetti_4d.ba59d479.svg";